import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-auth-callback',
  template: `
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Completing sign in...</p>
      </div>
    </div>
  `,
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const token = params['token'];
      const error = params['error'];
      const refreshToken = params['refreshToken'];

      this.authService.handleAuthCallback(token, refreshToken, error).subscribe({
        next: (success) => {
          if (!success) {
            console.error('Authentication callback failed');
          }
        },
        error: (err) => {
          console.error('Authentication error:', err);
          this.router.navigate(['/login'], {
            queryParams: { error: 'Authentication failed' },
          });
        },
      });
    });
  }
}
